export default "__VITE_ASSET__CdqrHP2J__"